import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { DateAdapter } from '@angular/material';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";

declare let swal:any;

@Component({
  selector: 'app-detail-promotion',
  templateUrl: './detail-promotion.component.html',
  styleUrls: ['./detail-promotion.component.css']
})
export class DetailPromotionComponent implements OnInit {

  errors: any = {};
  isLoading: boolean = false;

  environment: any;

  priceMaskOption: any = { prefix: '', thousands: ' ', decimal: ',', suffix: ' €', align: 'left', allowNegative: false };
  percentMaskOption: any = { prefix: '', thousands: ' ', decimal: ',', suffix: ' %', align: 'left', allowNegative: false };

  promotion: any = {
    product: {
      product_discounts: []
    }
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('fr');
  }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {
      let id = params['id'];
      if (id) {
        this.isLoading = true;
        var query = "";
        if (this.authService.connectedAs.admin == false)
          query += "?connectedAsId=" + this.authService.connectedAs.id;
        this.http.get(environment.API_PATH + '/product/discount/' + id + query, {withCredentials: true})
	      .subscribe(
          data => {
            this.isLoading = false;
            this.promotion = data;
          },
          err => {
            var errors = err.error;
            this.isLoading = false;
            if (errors.error) {
              if (errors.error.status === 401) {

                this.router.navigate(['/connexion']);
              } else if (errors.error.status === 403) {
                if (errors.error.details.redirect)
                  this.router.navigate([errors.error.details.redirect]);
                else
                  this.router.navigate(['connexion']);
              } else {
                this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
              }
            } else {
              this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
            }
          });
      }
      else
        this.router.navigate(['../..'], {relativeTo: this.route});
    });
  }

  goBack() {
    this.router.navigate(['administration', 'promotions']);
  }

  seePromotion(id: number): void {
    this.router.navigate(['../..', 'detail', id], {relativeTo: this.route});
  }

}



// WEBPACK FOOTER //
// ./src/app/detail-promotion/detail-promotion.component.ts